<div class="popup-container">
  <div class="popup-content-right">
    <i class="btn-close" (click)="onNoClick()"></i>
  </div>
  <div class="popup-content">
    <mat-icon class="material-icons-outlined {{ data.iconClassCss }}">
      {{ data.materialIcon }}
    </mat-icon>

    <div class="popup-title">
      {{ data.header }}
    </div>

    <div class="popup-subtitle {{ data.subTitleWidth }}">
      {{ data.subTitle }}
    </div>
    <div class="popup-actions">
      <button
        *ngIf="!data.cancelBtn && !data.cancelFlag"
        class="btn btn-secondary"
        (click)="onNoClick()"
      >
        Cancel
      </button>
      <button
        *ngIf="data.cancelFlag"
        class="btn btn-secondary"
        (click)="onNoClick()"
      >
        Discard
      </button>
      <button class="btn {{ data.buttonClassCss }}" (click)="success()">
        {{ data.successButtonName }}
      </button>
    </div>
  </div>
</div>
